<template>
  <div>
    <v-system-bar
      app
      dark
      height="40"
      color="primary"
      class="top-system-bar px-2 px-md-6"
    >
      <span class="d-none d-sm-inline font-weight-bold mr-2">VENTAS</span>
      <span class="caption text-no-wrap">958863622 / 938832424</span>
      <v-spacer />
      <a
        href="https://corpaveo.aveoperu.com/buscar"
        target="_blank"
        class="top-system-bar__link white--text text-decoration-none d-none d-md-flex align-center"
      >
        <!-- https://corpaveo.aveoperu.com/buscar -->
        <v-icon small color="white" class="mr-1">mdi-download</v-icon>
        <span class="caption font-weight-medium"
          >DESCARGA TU COMPROBANTE (XML)</span
        >
      </a>

      <div class="d-none d-md-flex align-center ml-4">
        <span class="caption mr-2">¿Quieres más Información?</span>

        <v-btn
          href="https://wa.me/51958863622"
          target="_blank"
          large
          depressed
          color="accent"
          class="secondary--text text-capitalize font-weight-bold"
        >
          <v-icon left>mdi-whatsapp</v-icon>
          Escríbenos
        </v-btn>
      </div>
    </v-system-bar>

    <v-app-bar
      app
      elevate-on-scroll
      color="white"
      class="app-navbar"
      height="72"
    >
      <div class="d-none d-md-flex" style="width: 200px">
        <router-link
          :to="{ name: 'Index' }"
          class="d-flex align-center text-decoration-none mr-4 navbar-brand"
        >
          <v-img
            :src="require('@/assets/logoaveo.png')"
            max-height="48"
            max-width="150"
            contain
            alt="Aveo Peru Logo"
            class="navbar-logo"
          />
          <div class="ml-3 d-none d-sm-block"></div>
        </router-link>
      </div>

      <div class="d-flex d-md-none align-center">
        <v-app-bar-nav-icon aria-label="Abrir menú" @click="drawer = true" />
        <router-link
          :to="{ name: 'Index' }"
          class="d-flex align-center text-decoration-none mr-4 navbar-brand"
        >
          <v-img
            :src="require('@/assets/logoaveo.png')"
            max-height="40"
            max-width="120"
            contain
            alt="Aveo Peru Logo"
          />
        </router-link>
      </div>

      <div class="d-none d-md-flex align-center justify-center flex-grow-1">
        <v-btn
          v-for="item in navItems"
          :key="item.title"
          text
          class="text-capitalize font-weight-medium"
          color="grey darken-3"
          v-bind="
            item.href
              ? { href: item.href, target: '_blank' }
              : item.action
              ? {}
              : { to: item.to }
          "
          exact
          @click="item.action ? item.action() : undefined"
        >
          {{ item.title }}
        </v-btn>
      </div>
      <div class="d-none d-md-flex" style="width: 200px">
        <!-- Espacio balanceado para el logo -->
      </div>

      <!-- <div class="d-none d-md-flex align-center">
        <v-btn text class="text-capitalize font-weight-medium" color="grey darken-3">
          Ingresar
        </v-btn>
        <v-btn
          rounded
          depressed
          color="primary"
          class="text-capitalize font-weight-bold px-6 ml-2"
        >
          Registrarse
        </v-btn>
      </div> -->

      <div class="d-flex d-md-none align-center">
        <v-btn icon color="primary" aria-label="Ingresar">
          <v-icon>mdi-login-variant</v-icon>
        </v-btn>
      </div>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      width="280"
      class="d-md-none"
    >
      <div class="pa-4 text-center">
        <v-img
          :src="require('@/assets/logoaveo.png')"
          max-height="56"
          contain
          alt="Aveo Peru Logo"
          class="mx-auto mb-2"
        />
        <div class="text-subtitle-2 font-weight-bold primary--text">
          Aveo Perú
        </div>
      </div>
      <v-divider />
      <v-list nav dense class="pt-4">
        <v-list-item
          v-for="item in navItems"
          :key="'m-' + item.title"
          v-bind="
            item.href
              ? { href: item.href, target: '_blank' }
              : item.action
              ? {}
              : { to: item.to }
          "
          link
          @click="
            item.action ? (item.action(), (drawer = false)) : (drawer = false)
          "
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="my-3" />
        <!-- <v-list-item>
          <v-btn block text class="justify-start">Ingresar</v-btn>
        </v-list-item>
        <v-list-item>
          <v-btn block depressed color="primary" rounded class="text-capitalize">Registrarse</v-btn>
        </v-list-item> -->
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "AppNavbar",
  data() {
    return {
      drawer: false,
    };
  },
  computed: {
    navItems() {
      return [
        { title: "Inicio", to: { name: "Index" } },
        { title: "Facturación Pymes", to: { name: "PequenosNegocios" } },
        { title: "Certificados Digitales", action: this.scrollToCertificados },
        { title: "Descargas", to: { name: "Descargas" } },
        { title: "Soporte", href: "https://www.aveoperu.com/helpdesk/" },
        { title: "Tutoriales", to: { name: "Tutoriales" } },
      ];
    },
  },
  methods: {
    scrollToCertificados() {
      const doScroll = () => {
        const el = document.getElementById("certificados");
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };
      if (this.$route.name !== "Index") {
        this.$router.push({ name: "Index" }).then(() => {
          this.$nextTick(() => setTimeout(doScroll, 300));
        });
      } else {
        doScroll();
      }
    },
  },
};
</script>

<style scoped>
.top-system-bar {
  font-size: 0.75rem;
}

.top-system-bar__link:hover {
  opacity: 0.9;
}

.navbar-brand {
  line-height: 1.1;
}

.app-navbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
}
</style>
